import React, { useMemo, useState } from "react";

import ShipeeziGrid, { Column } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";

import { paginate } from "../../../../../../../util/paginate";
import { Wrapper } from "./styles";

type ArrayT<T> = Array<T>;

type DespatchViewGridDataProps<T> = {
  data?: ArrayT<T>;
  columns: ArrayT<Column>;
};

const DespatchViewGridData: React.FC<DespatchViewGridDataProps<unknown>> = (props) => {
  const { data: allData, columns } = props;

  const { t: translate } = useTranslation();

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);

  const data = useMemo(() => {
    if (!allData || !allData.length) return [];

    return paginate(allData, page > 0 ? page - 1 : 0, pageSize);
  }, [allData, page, pageSize]);

  return (
    <Wrapper>
      <ShipeeziGrid
        showSelection={false}
        data={data}
        columns={columns}
        currentPage={page}
        onGoToPage={setPage}
        onPreviousPage={setPage}
        onNextPage={setPage}
        pageSize={pageSize}
        pageSizeList={[5, 10, 15, 20]}
        onChangePageSize={setPageSize}
        totalItems={allData?.length || 0}
        namePage={translate("items")}
      />
    </Wrapper>
  );
};

export { DespatchViewGridData };
